import { useEffect, useContext, useCallback } from 'react';

import { CallHistoryContext } from '../context-providers/CallHistoryContext';
import { CALL_DISCONNECTED_EVENT } from '../events/callEvents';

export const useCallDisconnectListener = () => {
  const { refetch } = useContext(CallHistoryContext);

  const handleCallDisconnected = useCallback(() => {
    setTimeout(() => refetch(), 500);
  }, [refetch]);

  useEffect(() => {
    window.addEventListener(CALL_DISCONNECTED_EVENT, handleCallDisconnected as EventListener);
    return () => window.removeEventListener(CALL_DISCONNECTED_EVENT, handleCallDisconnected as EventListener);
  }, [handleCallDisconnected]);
};
